import React from 'react';
import { cn } from '@/lib/utils';
import Icon, { IconComponent } from './Icon';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconComponent;
  /** Required: icon-only buttons need an accessible name. */
  label: string;
  /** Small red dot in the top-right corner (e.g. unread notifications). */
  badge?: boolean;
}

/** 40px square outlined button holding a single 20px icon. */
const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, label, badge, className, type = 'button', ...rest }, ref) => (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      className={cn(
        'tw-relative tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-ds-border-default tw-bg-ds-surface tw-text-ds-text-primary tw-transition-colors hover:tw-bg-ds-subtle',
        'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ds-brand',
        className,
      )}
      {...rest}
    >
      <Icon icon={icon} size={20} />
      {badge && (
        <span aria-hidden className="tw-absolute tw-right-2 tw-top-2 tw-h-2 tw-w-2 tw-rounded-full tw-bg-ds-danger-fg tw-ring-2 tw-ring-ds-surface" />
      )}
    </button>
  ),
);

IconButton.displayName = 'IconButton';

export default IconButton;
